<template>
    <div class="top-navigation">
      <div class="content">
        <div class="nav-left">
          <span><img src="../../assets/work-time.svg"></span>
          <span class="opening-hours">ODPIRALNI ČAS: {{ openingTime[0].value }}</span>
        </div>
        <div class="nav-right">
          <span><img src="../../assets/work-time.svg"></span>
          <span class="opening-hours">DOSTAVA: {{ openingTimeDelivery[0].value }}</span>
        </div>
      </div>
    </div>
</template>

<style lang="scss">   
@import 'topnavbar.scss';
</style>

<script>

export default {
    computed: {
        settings() {
        return this.$store.getters.allSettings
        },

        openingTime() {
        return this.settings.filter(setting => setting.name === 'odpiralni_cas')
        },

        openingTimeDelivery() {
        return this.settings.filter(setting => setting.name === 'odpiralni_cas_dostava')
        },
	},
	mounted() {
		this.$store.dispatch("getSettings")
	},

}

</script>